module.exports = __webpack_public_path__ + "img/sanfei_bg.f8d69860.png";